import { createSlice } from "@reduxjs/toolkit";
import type { AppThunk } from "src/store";
import axios from "../utils/axios";



interface GenerateQR {
    GenrateQRData: {
        projectIds: any;
        productOptionForCode:[];
        productIDData:[],
        productOptionForCodeDropDown:[],
       
    },
    GenerateAllData: {
        Data: []
    },
    AlertMessageState: {
        show: boolean;
        type: string;
        message: string;
        showModal: boolean;
      };
}


const initialState: GenerateQR = {
    GenrateQRData: {
        projectIds: [],
        productOptionForCode: [],
        productIDData: [],
        productOptionForCodeDropDown: [],
       
    },
    GenerateAllData: {
        Data: []
    },
    AlertMessageState: null,
}

const slice = createSlice({
    name: "GenerateQR",
    initialState,
    reducers: {
        GetProducts(state, action) {
            state.GenrateQRData = {
                ...state.GenrateQRData,
                projectIds: action.payload,
            };
        },
        setProductIDData(state, action) {
            state.GenrateQRData = {
                ...state.GenrateQRData,
                productIDData: action.payload,
            }
        },
        setProductOptionForCode(state, action) {
            state.GenrateQRData = {
                ...state.GenrateQRData,
                productOptionForCode: action.payload,
            }
        },
        setProductOptionForCodeEmpty(state, action) {
            state.GenrateQRData = {
                ...state.GenrateQRData,
                productOptionForCode: [],
            }
        },
        setProductOptionForCodeDropdown(state, action) {
            state.GenrateQRData = {
                ...state.GenrateQRData,
                productOptionForCodeDropDown: action.payload
            }
        },
        setGenerateAllData(state, action) {
            state.GenerateAllData = {
                ...state.GenerateAllData,
                Data: action.payload
            }
        },
        setGenerateErrorData: (state, action) => {
            state.GenerateAllData = {
                ...state.GenerateAllData,
                Data: action.payload
            };

        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
              show: true,
              type: action.payload.type,
              message: action.payload.message,
              showModal: action.payload.showModal,
            };
          },
          clearAlertMessage(state) {
            state.AlertMessageState = {
              show: false,
              type: null,
              message: null,
              showModal: false,
            };
          },
        
    }

});

export const getAllProducts = (optioanl?:any): AppThunk => async (dispatch: any) => {

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/projects/list`;
    axios.get(apiUrl)
        .then((response) => {
            let projectIds: any = [];
            response.data.data.map((d: any) => {
                let obj = { value: d, label: d };
                projectIds.push(obj);
            })
            dispatch(slice.actions.GetProducts(projectIds))

        })
        .catch((error) => {
            dispatch(slice.actions.showAlertMessage({
                message: error.message,
                type: "error"
            }));
        });
}

export const getProjectIds = (prodcutId: any): AppThunk => async (dispatch: any) => {


    const apiUrl = `${process.env.REACT_APP_BASE_URL}/projects/${prodcutId}/products`;

    axios.get(apiUrl)
        .then((response) => {

            let products = response.data.data.sort(), productArr: any = [], productArrDropDown: any = [];
            products.map((d: any) => {
                let productId = d.split('-').slice(-1).join(',').replaceAll(',', "-");
                productArr.push(productId);

                let field = {
                    label: d.split('-').slice(-1).join(',').replaceAll(',', "-"),
                    value: d.split('-').slice(-1).join(',').replaceAll(',', "-")
                }
                productArrDropDown.push(field);
            })
            dispatch(slice.actions.setProductOptionForCode(productArr));
            dispatch(slice.actions.setProductOptionForCodeDropdown(productArrDropDown));
            dispatch(slice.actions.setProductIDData(products));

        })
        .catch((error) => {
            dispatch(slice.actions.showAlertMessage({
                message: error.message,
                type: "error"
            }));
        })

}

export const getProjectProduct = (prodcutId: any): AppThunk => async (dispatch: any) => {

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/projects/${prodcutId}/products`;

    axios.get(apiUrl)
        .then((response) => {

            let products = response.data.data.sort();
            let projectIdsWithProductsArr: any = {};
            products.map((d: any) => {
                let productId = d.split('-').slice(-1).join(',').replaceAll(',', "-");
                projectIdsWithProductsArr[productId] = d;
            });
            dispatch(slice.actions.setGenerateAllData(projectIdsWithProductsArr));

        })
        .catch((error) => {
            dispatch(slice.actions.setGenerateErrorData(error));
        })

}

export const reducer = slice.reducer;
export default slice;